module.exports = __webpack_public_path__ + "static/media/email.80e4de35.svg";